import http from '@/communication/AuthConnection'

export default async ({ commit }) => {
  try {
    const defaultDistributor = await http.get('/v1/distributor/load-default')
    commit('DEFAULT_DISTRIBUTOR', defaultDistributor.data.defaultDistributor)
  } catch (error) {
    return Error(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/distributor/load-default-distributor/index.js